import { CanAccess, useTranslate } from "ra-core";
import { Navigate } from "react-router";

import { InternalNoticeConfigCard } from "./InternalNoticeConfigCard";
import { InternalNoticeUsageCard } from "./InternalNoticeUsageCard";
import { InternalNoticeUsersCard } from "./InternalNoticeUsersCard";

const SettingsContent = () => {
  const translate = useTranslate();
  return (
    <div className="mx-auto mt-2 max-w-3xl space-y-4 pb-8">
      <h1 className="px-1 text-2xl font-bold">
        {translate("crm.internalNotices.settings.title")}
      </h1>
      <p className="px-1 text-[15px] text-muted-foreground">
        {translate("crm.internalNotices.settings.intro")}
      </p>
      <InternalNoticeUsersCard />
      <InternalNoticeUsageCard />
      <InternalNoticeConfigCard />
    </div>
  );
};

/**
 * Almikia Epic EN (TASK-091): the Direccion 'Avisos internos' settings screen: who receives the
 * internal WhatsApp notices (per-user switch, default OFF), the usage counter of the ALERTS
 * number, the test notice and the data-valued config. Direccion only: every other role, and an
 * identity without a role, is sent home; the RLS and RPC gates of TASK-087 reject their writes
 * anyway.
 */
export const InternalNoticesSettings = () => (
  <CanAccess
    resource="internal_notices_settings"
    action="list"
    accessDenied={<Navigate to="/" replace />}
  >
    <SettingsContent />
  </CanAccess>
);

InternalNoticesSettings.path = "/internal_notices_settings";
